var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.451 8.981h5.637V27H.45V8.981ZM3.27 0a3.264 3.264 0 0 1 3.023 2.029 3.283 3.283 0 0 1-.721 3.574 3.267 3.267 0 0 1-5.57-2.355C0 2.387.34 1.56.948.95A3.238 3.238 0 0 1 3.241 0h.028Zm6.285 27h5.637v-8.896c0-2.373.451-4.632 3.354-4.632s2.818 2.683 2.818 4.773V27H27v-9.885c0-4.858-1.071-8.473-6.708-8.473a5.852 5.852 0 0 0-5.298 2.825V8.98H9.639L9.554 27Z",
    fill: "#DDD"
  })));
};

export default SvgLinkedIn;